import { useCopyToClipboard } from '@modules/common/hooks';
import { ContentCopyRounded } from '@mui/icons-material';
import { Stack, Tooltip, Typography, TypographyVariant } from '@mui/material';
import { useState } from 'react';

interface IntegrationCardDetailsTextProps {
  text: string | undefined;
  prefixText?: string;
  variant?: TypographyVariant;
  maxWidth?: string;
  color?: string;
  showClickToCopyTooltip?: boolean;
}

export const IntegrationCardDetailsText = ({
  text,
  prefixText,
  variant = 'caption',
  maxWidth = '300px',
  color = 'text.primary',
  showClickToCopyTooltip,
}: IntegrationCardDetailsTextProps) => {
  const copyTextToClipboard = useCopyToClipboard();
  const [shouldShowCopyIcon, setShouldShowCopyIcon] = useState(false);

  if (!text) {
    return null;
  }

  return (
    <Stack direction="row" columnGap={1} alignItems="center" flexWrap="wrap">
      {prefixText && (
        <Typography variant={variant} color="text.secondary">
          {prefixText}
        </Typography>
      )}
      <Stack
        role="button"
        direction="row"
        spacing={1}
        alignItems="center"
        overflow="hidden"
        textOverflow="ellipsis"
        maxWidth={maxWidth}
        onClick={() => copyTextToClipboard(text)}
        onMouseEnter={() => setShouldShowCopyIcon(true)}
        onMouseLeave={() => setShouldShowCopyIcon(false)}
      >
        <Tooltip
          title={showClickToCopyTooltip ? 'Click to copy' : text}
          placement="top"
          arrow
          disableInteractive
        >
          <Typography variant={variant} noWrap color={color}>
            {text}
          </Typography>
        </Tooltip>
        {shouldShowCopyIcon && (
          <ContentCopyRounded
            sx={{
              fontSize: (theme) => theme.typography[variant].fontSize,
              color: 'text.secondary',
            }}
          />
        )}
      </Stack>
    </Stack>
  );
};
